module.exports = __webpack_public_path__ + "img/T615.79cc1c1e.jpg";